export function sanitizeHubRedirectUrl(value?: string | null): string | null {
  if (!value) return null

  try {
    const url = new URL(value)
    if (url.protocol !== 'https:') return null

    const path = `${url.pathname}${url.search}${url.hash}`

    if (url.hostname === 'hub.stone.com.br') return `https://hub.stone.com.br${path}`
    if (url.hostname === 'sandbox.hub.stone.com.br') return `https://sandbox.hub.stone.com.br${path}`

    return null
  } catch {
    return null
  }
}

export function isTrustedHubUrl(value?: string | null): boolean {
  return sanitizeHubRedirectUrl(value) !== null
}
